import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_URL } from "../../configurations/server-config";

@Injectable({
  providedIn: "root",
})
export class BagageService {
  constructor(private http: HttpClient) {}

  getAllbagage(page = 0, size = 100): any {
    return this.http.get(`${API_URL}/bagage?page=${page}&size=${size}`);
  }

  savebagage(bagage: any): any {
    return this.http.post(`${API_URL}/bagage`, bagage, {
      observe: "response",
    });
  }

  updatebus(bagage: any): any {
    return this.http.put(`${API_URL}/bagage`, bagage, {
      observe: "response",
    });
  }

  getbagageinsession(session: any): any {
    return this.http.get(`${API_URL}/bagagesession/${session}`);
  }

  getamountbagageinsession(session: any): any {
    return this.http.get(`${API_URL}/amountbagagesession/${session}`);
  }

  getAllBagage(page = 0, size = 10): any {
    return this.http.get(`${API_URL}/bagage?page=${page}&size=${size}`);
  }

  // getbagageinsession(session: any): any {
  //   return this.http.get(`${API_URL}/bagagesession/${session}`);
  // }

  getallbagageinSession(session: any, page: any, size: any): any {
    return this.http.get(
      `${API_URL}/bagageinsessions/${session}?page=${page}&size=${size}`
    );
  }

  getbagagesummary(session: any): any {
    return this.http.get(`${API_URL}/bagagesummary?id=${session}`);
  }

  searchBagage(param: any): any {
    return this.http.post(`${API_URL}/searchbagage?q=${param}`, null);
  }

  cancelBagage(param: any): any {
    return this.http.delete(`${API_URL}/bagage?id=${param}`);
  }
}
